import Vue from "vue";

Vue.directive('keep-only-character-pwd', {
    bind: function (el, binding, vnode) {
        const handler = function (e) {
            let value = e.target.value;
            const newValue = value.replace(/[^a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?{}[\]~@^_|]+/g, '')

            if (newValue !== value) {
                e.target.value = newValue
                vnode.elm.dispatchEvent(new CustomEvent('input'))
            }
        };

        el.addEventListener('input', handler);
    },
});
